import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
export const IS_REFRESH_TOKEN = new HttpContextToken<boolean>(() => false);

const PUBLIC_PATH_FRAGMENTS = [
  '/api/v1/auth/login',
  '/api/v1/auth/clients/login',
  '/api/v1/auth/clients/two-factor',
  '/api/v1/auth/clients/resend-otp',
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH) || PUBLIC_PATH_FRAGMENTS.some((p) => req.url.includes(p))) {
    return next(req);
  }

  const tokens = inject(TokenStorageService);
  const token = req.context.get(IS_REFRESH_TOKEN)
    ? tokens.getRefreshToken()
    : tokens.getAccessToken();
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
